module.exports = __webpack_public_path__ + "img/B高通锐化1.071b49c9.png";